import { render, staticRenderFns } from "./BindsMenuContent.vue?vue&type=template&id=3f2d94a0&"
import script from "./BindsMenuContent.vue?vue&type=script&lang=js&"
export * from "./BindsMenuContent.vue?vue&type=script&lang=js&"
import style0 from "./BindsMenuContent.vue?vue&type=style&index=0&id=3f2d94a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports